import { useCallback, useState } from "react";
import NoPortalDataIllustration from "./NoPortalData";
import { Pie, PieChart, Cell, ResponsiveContainer, Legend, Sector } from "recharts";
import { useTranslation } from "react-i18next";

function IssuesStatusGraphTile({ graphIssuesDataByStatus }) {
  // const [graphDataByStatus, setGraphDataByStatus] = useState({ OPEN: 5, CLOSED: 5, IN_REVIEW: 5 });
  const COLORS = ["#e75555", "#ffe973", "#2c80ff", "#45cf80", "#ffb573"];
  const [activeIndex, setActiveIndex] = useState(null);
  const { t } = useTranslation();
  const onMouseOver = useCallback((data, index) => {
    setActiveIndex(index);
  }, []);
  const onMouseLeave = useCallback(() => {
    setActiveIndex(null);
  }, []);

  const renderColorfulLegendText = (index) => (
    <span style={{ color: "#596579", fontWeight: 500, padding: "10px" }}>
      {Object.keys(graphIssuesDataByStatus)[index]}
    </span>
  );

  const renderColorFullCount = (index) => (
    <span style={{ color: "#192048", fontWeight: 600, padding: "10px" }}>
      {Object.values(graphIssuesDataByStatus)[index]}
    </span>
  );

  const renderActiveShape = (props) => {
    const RADIAN = Math.PI / 180;
    const { cx, cy, innerRadius, outerRadius, startAngle, endAngle, midAngle } = props;
    const sin = Math.sin(-RADIAN * midAngle);
    const cos = Math.cos(-RADIAN * midAngle);
    const sx = cx + (outerRadius - 10) * cos;
    const sy = cy + (outerRadius - 10) * sin;
    return (
      <Sector
        cx={sx}
        cy={sy}
        innerRadius={innerRadius}
        outerRadius={outerRadius}
        startAngle={startAngle}
        endAngle={endAngle}
      />
    );
  };

  return Object.values(graphIssuesDataByStatus).filter((a) => a > 0).length > 0 ? (
    <ResponsiveContainer height="100%" width="100%">
      <PieChart>
        <Legend
          id="text"
          iconType="circle"
          layout="centric"
          align="right"
          verticalAlign="middle"
          formatter={renderColorfulLegendText}
        />
        <Legend
          id="count"
          iconType="circle"
          layout="centric"
          align="right"
          verticalAlign="middle"
          formatter={renderColorFullCount}
        />
        <Pie
          activeIndex={activeIndex}
          data={[
            { x: "Open", y: graphIssuesDataByStatus.OPEN },
            {
              x: "In Review",
              y: graphIssuesDataByStatus.IN_REVIEW,
            },
            { x: "Closed", y: graphIssuesDataByStatus.CLOSED },
          ]}
          dataKey="y"
          innerRadius="30%"
          activeShape={renderActiveShape}
          onMouseOver={onMouseOver}
          onMouseLeave={onMouseLeave}
          cx="50%"
          cy="50%"
        >
          {Object.keys(graphIssuesDataByStatus).map((entry, index) => (
            <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
          ))}
        </Pie>
      </PieChart>
    </ResponsiveContainer>
  ) : (
    <NoPortalDataIllustration name={t("Issues")} />
  );
}

export default IssuesStatusGraphTile;
